import { addDays, dateIsBefore } from 'lib/datetime/dateUtils'

export interface RegionalRuleOptions {
  /**
   * Offers cancellation protection to Maldives and Fiji stays, which otherwise keep travel
   * insurance as their only protection. The Indonesia lead-time rule always applies.
   */
  offerFijiAndMaldives?: boolean
}

export default function verifyItemFollowsRegionalRules(
  countryCode?: string,
  earliestCheckingDate?: Date,
  { offerFijiAndMaldives = false }: RegionalRuleOptions = {},
) {
  if (!countryCode || !earliestCheckingDate) return false

  // Maldives
  if (countryCode === 'MV') return offerFijiAndMaldives

  if (
    // Indonesia or Fiji
    countryCode === 'ID' || (countryCode === 'FJ' && !offerFijiAndMaldives)
  ) {
    const thirtyDaysFromNow = addDays(new Date(), 30)
    if (dateIsBefore(earliestCheckingDate, thirtyDaysFromNow)) {
      return false
    }
  }

  return true
}
